import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlaylistService {

  private youtubeToken = 'AIzaSyB8NWGxzoPjMEn5hSeqywN5JoQOrM-g8tk';
  private youtubeUrl = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&playlistId'

  constructor(
    private http: HttpClient
  ) { }

  getPlayList(playListUrl: string) {
    return this.http.get(`${this.youtubeUrl}=${playListUrl}&key=${this.youtubeToken}`);
  }

  getTRainerPlaylist(playListUrl: string): Observable<any> {
    return this.http.get(`${this.youtubeUrl}=${playListUrl}&key=${this.youtubeToken}`);
  }
}
